import React from "react";
import CoursePicture from "../../../courseItem/coursePicture/CoursePicture";
import EventDates from "../EventDates";
import classes from "./CourseGalleryItemV2.module.css";

const CourseGalleryItemV2 = ({ course }) => {
    return (
        <div className={classes.CourseGalleryItemV2}>
            <div className={classes.ImageSection}>
                <CoursePicture picture={course?.picture} courseId={course?.externalId} course={course} />
            </div>
            <div className={classes.ContentSection}>
                <div className={classes.Text}>
                    <div className={classes.CourseTitle}>
                        {course?.name}
                    </div>
                    <div className={classes.CourseDescription}>
                        {course?.description}
                    </div>
                </div>
                <EventDates
                    eventFromDate={course?.calendarEvents?.[0]?.from}
                    eventToDate={course?.calendarEvents?.[0]?.to}
                    className={classes.EventDatesSection}
                    datesClassName={classes.EventDatesText}
                    iconSize="21px"
                    iconColor="#000"
                />
                {course?.providerLogo &&
                    <div className={classes.ProviderLogo}>
                        <img src={course?.providerLogo} alt="Provider" className={classes.LogoImage} />
                    </div>
                }
            </div>
        </div>
    );
};

export default CourseGalleryItemV2;
